import { render, staticRenderFns } from "./PlusSkillsMarketCard.vue?vue&type=template&id=05488c20&scoped=true"
import script from "./PlusSkillsMarketCard.vue?vue&type=script&lang=js"
export * from "./PlusSkillsMarketCard.vue?vue&type=script&lang=js"
import style0 from "./PlusSkillsMarketCard.vue?vue&type=style&index=0&id=05488c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05488c20",
  null
  
)

export default component.exports